import { render, staticRenderFns } from "./BackofficeDeployments.vue?vue&type=template&id=540bd0f0&scoped=true"
import script from "./BackofficeDeployments.vue?vue&type=script&lang=js"
export * from "./BackofficeDeployments.vue?vue&type=script&lang=js"
import style0 from "./BackofficeDeployments.vue?vue&type=style&index=0&id=540bd0f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540bd0f0",
  null
  
)

export default component.exports